import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useTheme } from '@mui/material';

import { getProviders } from '../../../redux/providers/providers.slice';
import { setPageTitle } from '../../../redux/title/title.slice';

import PrimaryButton from '../../../components/ui/buttons/primaryButton';
import Loader from '../../../components/ui/loader';
import { FTable, FTableCell } from '../../../components/ui/table';

function HouseManagement() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();

  const { providers, loading } = useSelector((state) => state.providers);

  useEffect(() => {
    dispatch(setPageTitle('House Management'));
    dispatch(getProviders());
  }, [dispatch]);

  if (loading) {
    return <Loader loading={true} message="Loading providers ..." />;
  }

  const columns = [{ label: 'Manco / LISP Name' }, { label: 'Broker House Code' }, { label: '' }];

  return (
    <FTable
      title="House Codes"
      columns={columns}
      rows={providers}
      emptyMessage="No providers found"
      renderRow={(provider) => (
        <>
          <FTableCell>{provider.friendlyName || provider.clientName || '—'}</FTableCell>

          <FTableCell>{provider.externalId1 || '—'}</FTableCell>

          <FTableCell>
            <PrimaryButton onClick={() => navigate(`/provider/advisors/${provider.id}`)}>
              View Advisors
            </PrimaryButton>
          </FTableCell>
        </>
      )}
    />
  );
}

export default HouseManagement;
